import {
  FEEDBACK_HOME_FEED_ENDPOINT,
  FEEDBACK_SCENE_KIND,
  assertNever,
  sceneHomeFeed,
  sceneUnknown,
  type Scene,
} from './types';

/**
 * Returns the baseline feedback scene used during root resets before tracked
 * routes authoritatively set their own scene values.
 */
export function deriveScene(pathname: string, isLoggedIn: boolean): Scene {
  if (pathname === '/') {
    return sceneHomeFeed(
      isLoggedIn ? FEEDBACK_HOME_FEED_ENDPOINT.UNIFIED : FEEDBACK_HOME_FEED_ENDPOINT.PUBLIC
    );
  }

  return sceneUnknown();
}

/**
 * Produces a stable, value-based key for a scene used to dedupe scene updates.
 *
 * The switch is exhaustive so TypeScript errors when a new scene kind is added.
 */
export function sceneKey(scene: Scene): string {
  switch (scene.kind) {
    case FEEDBACK_SCENE_KIND.DOC_THREAD:
      return `${scene.kind}:${scene.thread_id}:${scene.main_topic ?? ''}`;
    case FEEDBACK_SCENE_KIND.GUIDE_PAGE:
      return `${scene.kind}:${scene.topic_key}`;
    case FEEDBACK_SCENE_KIND.PRODUCT_PAGE:
      return `${scene.kind}:${scene.product_ref}`;
    case FEEDBACK_SCENE_KIND.HOME_FEED:
      return `${scene.kind}:${scene.endpoint}`;
    case FEEDBACK_SCENE_KIND.UNKNOWN:
      return scene.kind;
    default:
      return assertNever(scene);
  }
}
